import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useRegistrationStatusChartsDataContext } from './hooks/useRegistrationStatusChartsDataContext';

export const Homeless = () => {
    const { chartData } = useRegistrationStatusChartsDataContext();

    return (
        <Donut
            title={'Situação de Rua'}
            subtitles={chartData?.homeless?.map((item) => item.description)}
            chartData={chartData?.homeless || []}
            colors={defaultColors.slice(0, chartData?.homeless?.length) || []}
            height={350}
            className="aligned-container"
        />
    );
};
